// extracted by mini-css-extract-plugin
export default {"form__inner":"SelectInput_form__inner__xy1bO","form__inner__input":"SelectInput_form__inner__input__wkZ2L"};